/**
 * System events that can be emitted by workflows
 * These events can trigger other workflows or be consumed by external systems
 */
export enum SystemEvent {
  // Email ingestion events
  EMAIL_INGESTED = "EMAIL_INGESTED",
  EMAIL_ROUTED_EMAIL_RULE = "EMAIL_ROUTED_EMAIL_RULE",
  EMAIL_ROUTED_AR_REMITTANCE = "EMAIL_ROUTED_AR_REMITTANCE",

  // AP invoice events
  AP_INVOICE_ACCEPTED = "AP_INVOICE_ACCEPTED",

  // Task events
  TASK_CREATED = "TASK_CREATED",
  // Emitted when any task is completed. Counterpart to TASK_CREATED; carries the
  // task category + linked entity + result so a workflow can re-trigger off it
  // (e.g. OMS v3 workflow-3 re-runs when a sales-order approval/action task is
  // completed). Single re-trigger event for both approvals and corrective actions.
  TASK_COMPLETED = "TASK_COMPLETED",

  // AR sales order events
  SALES_ORDER_APPROVED = "SALES_ORDER_APPROVED",

  // OMS v3 draft-sales-order routing/handoff events
  // Routing org → target org (cross-org): the routing workflow classified the
  // target org and hands the draft off (carries targetOrganizationId).
  DRAFT_SALES_ORDER_ROUTED = "DRAFT_SALES_ORDER_ROUTED",
  // Target org, intra-org: the target org's extract/line-breakout workflow has
  // populated the draft and it is ready for the approval-chain workflow.
  DRAFT_SALES_ORDER_READY = "DRAFT_SALES_ORDER_READY",
  // Routing org: classify_organization could not confidently match a target org;
  // emitted so an admin-notification workflow can alert the Gently team to
  // manually assign (→ reassign_draft_sales_order).
  DRAFT_SALES_ORDER_UNCLASSIFIED = "DRAFT_SALES_ORDER_UNCLASSIFIED",

  // AR approval events (discount and order-level approvals)
  APPROVAL_NEEDED = "APPROVAL_NEEDED",

  // Rebate CSV transform (workflow started via API with session + artifact context)
  REBATE_CSV_TRANSFORM_STARTED = "REBATE_CSV_TRANSFORM_STARTED",

  // Slack webhook received (Events API callbacks, interactivity payloads,
  // slash commands). Only emitted when the server has Slack credentials
  // configured AND the org has installed the Slack integration; hidden
  // from trigger pickers otherwise.
  SLACK_WEBHOOK_RECEIVED = "SLACK_WEBHOOK_RECEIVED",
}
